import { useLazyQuery } from '@apollo/client'
import { useEffect, useState } from 'react'

import { fromDTO } from './api/mapper'
import { GET_DOMAIN_BIDDERS } from './api/query'
import { DomainBidderSliceDTO } from './api/types'
import { DomainBidderSlice, UseGetDomainBidders, UseGetDomainBiddersProps } from './types'

export const useGetDomainBidders = ({
  domainId,
}: UseGetDomainBiddersProps): UseGetDomainBidders => {
  const [domainBidders, setDomainBidders] = useState<DomainBidderSlice[] | undefined>()

  const [query] = useLazyQuery(GET_DOMAIN_BIDDERS, {
    onCompleted: ({ domainBidders: { nodes: bidders } }): void => {
      if (bidders) {
        setDomainBidders(
          bidders.map((bidder: DomainBidderSliceDTO): DomainBidderSlice => fromDTO(bidder)),
        )
      }
    },
  })

  useEffect(() => {
    if (domainId) {
      query({
        variables: {
          domainId,
        },
      })
    }
  }, [domainId])

  return { domainBidders }
}
